<template>
  <div v-if="asyncDataStatus_ready">
    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-btn hidden color="#0F998E" class="white--text" @click="saveOrder">
          Shrani vrstni red
          <v-icon right dark>mdi-check</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({ name: 'MyCompanyPrintersLocationsNew' })"
        >
          Nova lokacija
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
<v-col  v-if="this.locations.length">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Lokacije tiskalnikov
                </th>

                <th></th>
              </tr>
            </thead>
          </template>
        </v-simple-table>
      </v-col>
    <v-row
      v-if="this.locations.length"
      v-dragula="localLocations"
      drake="locations"
    >

      <v-col
        v-for="item in localLocations"
        :key="item.id"
        :data-id="item.id"
        cols="12"
        class="pt-0 pb-0 "
      >
        <TitleOnlyCard
          :style="{ 'border-left': `5px solid ${item.color}` }"
          :title="item.name"
          :draggable="true"
          @delete="
            showDeleteLocationsModal = true;
            deleteLocations = item;
          "
          @edit="
            $router.push({
              name: 'MyCompanyPrintersLocationsEdit',
              params: { id: item.id }
            })
          "
        />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove lokacije printerjev uporabite gumb desno
          zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje loakcije"
      text="Ali ste prepričani, da želite izbrisati lokacijo? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteLocationsModal"
      @confirmed="remove(deleteLocations)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    TitleOnlyCard
  },
  mixins: [asyncDataStatus],
  data () {
    return {
      filter: '',
      showDeleteLocationsModal: false,
      deleteLocations: null,
      localLocations: []
    }
  },
  computed: {
    locations () {
      return objectToArray(this.$store.state.printerslocations.items)
    },
    filteredLocations () {
      return this.locations.filter(item =>
        siIncludes({ haystack: `${item.name}`, needle: this.filter })
      )
    }
  },
  methods: {
    ...mapActions('printerslocations', [
      'loadItems',
      'deleteItem',
    ]),
    remove (item) {
      deleteItem(item, this)
    },
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({
        type: 'error',
        text: 'Potrebna je vsaj ena aktivna poslovna enota'
      })
    } else {
      this.loadItems()
        .then(locations => {
          this.localLocations = this.locations
          this.asyncDataStatus_fetched()
        })
        .catch((err) => console.log(err.message))
    }
  },
  watch: {
    locations (newLocations) {
      this.localLocations = newLocations
    }
  }
}
</script>
